import styled, { css } from 'styled-components';
import { ITypography } from '../../@types/typography';

export const Headline1 = styled.h1(
  ({
    theme,
    color = 'oxfordBlue',
    ellipsis = false,
    fontStyle = 'normal',
    fontWeight = 'semiBold',
  }: ITypography) => css`
    font-family: 'Source Sans Pro', sans-serif;
    font-weight: ${theme.fontWeight[fontWeight]};
    font-size: ${theme.fontSize.xxxl};
    color: ${theme.colors[color]};
    letter-spacing: 0;
    line-height: ${theme.lineHeight.lh1};
    font-style: ${fontStyle};
    ${ellipsis && { 'white-space': 'nowrap' }};
    ${ellipsis && { overflow: 'hidden' }};
    ${ellipsis && { 'text-overflow': 'ellipsis' }};
  `
);

export const Headline2 = styled.h2(
  ({
    theme,
    color = 'oxfordBlue',
    ellipsis = false,
    fontStyle = 'normal',
    fontWeight = 'semiBold',
  }: ITypography) => css`
    font-family: 'Source Sans Pro', sans-serif;
    font-weight: ${theme.fontWeight[fontWeight]};
    font-size: ${theme.fontSize.xxl};
    color: ${theme.colors[color]};
    letter-spacing: 0;
    line-height: ${theme.lineHeight.lh2};
    font-style: ${fontStyle};
    ${ellipsis && { 'white-space': 'nowrap' }};
    ${ellipsis && { overflow: 'hidden' }};
    ${ellipsis && { 'text-overflow': 'ellipsis' }};
  `
);

export const Headline3 = styled.h3(
  ({
    theme,
    color = 'oxfordBlue',
    ellipsis = false,
    fontStyle = 'normal',
    fontWeight = 'semiBold',
  }: ITypography) => css`
    font-family: 'Source Sans Pro', sans-serif;
    font-weight: ${theme.fontWeight[fontWeight]};
    font-size: ${theme.fontSize.xl};
    color: ${theme.colors[color]};
    letter-spacing: 0;
    line-height: ${theme.lineHeight.lh3};
    font-style: ${fontStyle};
    ${ellipsis && { 'white-space': 'nowrap' }};
    ${ellipsis && { overflow: 'hidden' }};
    ${ellipsis && { 'text-overflow': 'ellipsis' }};
  `
);

export const Headline4 = styled.h4(
  ({
    theme,
    color = 'oxfordBlue',
    ellipsis = false,
    fontStyle = 'normal',
    fontWeight = 'semiBold',
  }: ITypography) => css`
    font-family: 'Source Sans Pro', sans-serif;
    font-weight: ${theme.fontWeight[fontWeight]};
    font-size: ${theme.fontSize.m};
    color: ${theme.colors[color]};
    letter-spacing: 0;
    line-height: ${theme.lineHeight.lh4};
    font-style: ${fontStyle};
    ${ellipsis && { 'white-space': 'nowrap' }};
    ${ellipsis && { overflow: 'hidden' }};
    ${ellipsis && { 'text-overflow': 'ellipsis' }};
  `
);

export const Headline5 = styled.h5(
  ({
    theme,
    color = 'oxfordBlue',
    ellipsis = false,
    fontStyle = 'normal',
    fontWeight = 'semiBold',
  }: ITypography) => css`
    font-family: 'Source Sans Pro', sans-serif;
    font-weight: ${theme.fontWeight[fontWeight]};
    font-size: ${theme.fontSize.s};
    color: ${theme.colors[color]};
    letter-spacing: 0;
    line-height: ${theme.lineHeight.lh5};
    font-style: ${fontStyle};
    ${ellipsis && { 'white-space': 'nowrap' }};
    ${ellipsis && { overflow: 'hidden' }};
    ${ellipsis && { 'text-overflow': 'ellipsis' }};
  `
);

export const Headline6 = styled.h6(
  ({
    theme,
    color = 'oxfordBlue',
    ellipsis = false,
    fontStyle = 'normal',
    fontWeight = 'semiBold',
  }: ITypography) => css`
    font-family: 'Source Sans Pro', sans-serif;
    font-weight: ${theme.fontWeight[fontWeight]};
    font-size: ${theme.fontSize.xs};
    color: ${theme.colors[color]};
    letter-spacing: 0;
    line-height: ${theme.lineHeight.lh6};
    font-style: ${fontStyle};
    ${ellipsis && { 'white-space': 'nowrap' }};
    ${ellipsis && { overflow: 'hidden' }};
    ${ellipsis && { 'text-overflow': 'ellipsis' }};
  `
);

export const Headline7 = styled.span(
  ({
    theme,
    color = 'oxfordBlue',
    ellipsis = false,
    fontStyle = 'normal',
    fontWeight = 'semiBold',
  }: ITypography) => css`
    font-family: 'Source Sans Pro', sans-serif;
    font-weight: ${theme.fontWeight[fontWeight]};
    font-size: ${theme.fontSize.xxs};
    color: ${theme.colors[color]};
    letter-spacing: 0;
    line-height: ${theme.lineHeight.lh7};
    font-style: ${fontStyle};
    ${ellipsis && { 'white-space': 'nowrap' }};
    ${ellipsis && { overflow: 'hidden' }};
    ${ellipsis && { 'text-overflow': 'ellipsis' }};
  `
);

export const Body3 = styled.p(
  ({
    theme,
    color = 'oxfordBlue',
    ellipsis = false,
    fontStyle = 'normal',
    fontWeight = 'regular',
  }: ITypography) => css`
    font-family: 'Source Sans Pro', sans-serif;
    font-weight: ${theme.fontWeight[fontWeight]};
    font-size: ${theme.fontSize.xl};
    color: ${theme.colors[color]};
    letter-spacing: 0;
    line-height: ${theme.lineHeight.lh3};
    font-style: ${fontStyle};
    ${ellipsis && { 'white-space': 'nowrap' }};
    ${ellipsis && { overflow: 'hidden' }};
    ${ellipsis && { 'text-overflow': 'ellipsis' }};
  `
);

export const Body4 = styled.p(
  ({
    theme,
    color = 'oxfordBlue',
    ellipsis = false,
    fontStyle = 'normal',
    fontWeight = 'regular',
  }: ITypography) => css`
    font-family: 'Source Sans Pro', sans-serif;
    font-weight: ${theme.fontWeight[fontWeight]};
    font-size: ${theme.fontSize.m};
    color: ${theme.colors[color]};
    letter-spacing: 0;
    line-height: ${theme.lineHeight.lh4};
    font-style: ${fontStyle};
    ${ellipsis && { 'white-space': 'nowrap' }};
    ${ellipsis && { overflow: 'hidden' }};
    ${ellipsis && { 'text-overflow': 'ellipsis' }};
  `
);

export const Body5 = styled.p(
  ({
    theme,
    color = 'oxfordBlue',
    ellipsis = false,
    fontStyle = 'normal',
    fontWeight = 'regular',
  }: ITypography) => css`
    font-family: 'Source Sans Pro', sans-serif;
    font-weight: ${theme.fontWeight[fontWeight]};
    font-size: ${theme.fontSize.s};
    color: ${theme.colors[color]};
    letter-spacing: 0;
    line-height: ${theme.lineHeight.lh5};
    font-style: ${fontStyle};
    ${ellipsis && { 'white-space': 'nowrap' }};
    ${ellipsis && { overflow: 'hidden' }};
    ${ellipsis && { 'text-overflow': 'ellipsis' }};
  `
);

export const Body6 = styled.p(
  ({
    theme,
    color = 'oxfordBlue',
    ellipsis = false,
    fontStyle = 'normal',
    fontWeight = 'regular',
  }: ITypography) => css`
    font-family: 'Source Sans Pro', sans-serif;
    font-weight: ${theme.fontWeight[fontWeight]};
    font-size: ${theme.fontSize.xs};
    color: ${theme.colors[color]};
    letter-spacing: 0;
    line-height: ${theme.lineHeight.lh6};
    font-style: ${fontStyle};
    ${ellipsis && { 'white-space': 'nowrap' }};
    ${ellipsis && { overflow: 'hidden' }};
    ${ellipsis && { 'text-overflow': 'ellipsis' }};
  `
);

export const Body7 = styled.p(
  ({
    theme,
    color = 'oxfordBlue',
    ellipsis = false,
    fontStyle = 'normal',
    fontWeight = 'regular',
  }: ITypography) => css`
    font-family: 'Source Sans Pro', sans-serif;
    font-weight: ${theme.fontWeight[fontWeight]};
    font-size: ${theme.fontSize.xxs};
    color: ${theme.colors[color]};
    letter-spacing: 0;
    line-height: ${theme.lineHeight.lh7};
    font-style: ${fontStyle};
    ${ellipsis && { 'white-space': 'nowrap' }};
    ${ellipsis && { overflow: 'hidden' }};
    ${ellipsis && { 'text-overflow': 'ellipsis' }};
  `
);
